<div class="app-options-edit" [formGroup]="appOptionForm" *ngIf="appOption">
  <div class="page-title modal-header app-options-header">
    <h2>אפשרויות מערכת</h2>
  </div>

  <div class="app-options-content">
    <fieldset class="options-card settings-group">
      <legend>התנהגות המערכת</legend>
      <div class="toggles-grid">
        <div class="toggle-item">
          <mat-slide-toggle formControlName="testMode">
            מצב בדיקה
          </mat-slide-toggle>
        </div>

        <div class="toggle-item">
          <mat-slide-toggle formControlName="readingOnlyLastNameToPhone">
            הקראת שם משפחה בלבד לזיהוי בטלפון
          </mat-slide-toggle>
        </div>

        <div class="toggle-item">
          <mat-slide-toggle formControlName="withContactVoiceName">
            שלח שם מוקלט לזיהוי בטלפון
          </mat-slide-toggle>
        </div>

      </div>
    </fieldset>

    <fieldset class="options-card settings-group">
      <legend>גבייה ותוכניות תשלום</legend>
      <div class="toggles-grid">
        <div class="toggle-item">
          <mat-slide-toggle formControlName="autoChargePlansPayments">
            גביית הוראות קבע באופן אוטומטי
          </mat-slide-toggle>
        </div>

        <div class="toggle-item">
          <mat-slide-toggle formControlName="canChargeMinusAmount">
            אפשר גבייה בסכום שלילי
          </mat-slide-toggle>
        </div>
      </div>
    </fieldset>

    <fieldset class="options-card settings-group wide-card">
      <legend>איזיקאונט וקבלות</legend>
      <div class="toggles-grid toggles-grid--inline">
        <div class="toggle-item">
          <mat-slide-toggle formControlName="iziCountIsSandboxMode">
            מצב בדיקות איזיקאונט (Sandbox)
          </mat-slide-toggle>
        </div>

        <div class="toggle-item">
          <mat-slide-toggle formControlName="iziCountSendCopy">
            שליחת עותק קבלה למייל השולח
          </mat-slide-toggle>
        </div>
      </div>

      <div class="fields-grid">
        <div class="form-field-row">
          <label>מפתח API</label>
          <input class="form-control" apply-enter formControlName="iziCountApiKey">
        </div>

        <div class="form-field-row">
          <label>כתובת דוא"ל יוצאת לקבלות</label>
          <input type="email" class="form-control" apply-enter formControlName="iziCountSenderEmail">
        </div>
      </div>
    </fieldset>

    <fieldset class="options-card settings-group">
      <legend>כרטיס איש קשר וכתובת</legend>
      <div class="fields-grid">
        <div class="form-field-row">
          <label>פורמט כתובת</label>
          <select class="form-control" apply-enter formControlName="addressFormat">
            <option value="IL">ישראל</option>
            <option value="USA">ארצות הברית</option>
            <option value="UK">בריטניה</option>
          </select>
        </div>

        <div class="form-field-row">
          <label>שפת ברירת מחדל</label>
          <select class="form-control" apply-enter formControlName="defaultLanguage">
            <option *ngFor="let language of servicesData.Languages" [ngValue]="language.value">
              {{language.name}}
            </option>
          </select>
        </div>

        <div class="form-field-row">
          <label>שיוך ברירת מחדל</label>
          <select class="form-control" apply-enter formControlName="defaultAffiliation">
            <option *ngFor="let affiliation of servicesData.ContactAffiliations" [ngValue]="affiliation.value">
              {{affiliation.name}}
            </option>
          </select>
        </div>

        <div class="form-field-row">
          <label>סוג כתובת ברירת מחדל</label>
          <select class="form-control" apply-enter formControlName="defaultLocationType">
            <option *ngFor="let locationType of servicesData.LocationTypes" [ngValue]="locationType.value">
              {{locationType.name}}
            </option>
          </select>
        </div>

        <div class="form-field-row full-width toggle-row">
          <mat-slide-toggle formControlName="defaultForPost">
            כתובת חדשה מיועדת למשלוח דואר כברירת מחדל
          </mat-slide-toggle>
        </div>
      </div>
    </fieldset>

    <fieldset class="options-card settings-group">
      <legend>תרומות וברירות מחדל כספיות</legend>
      <div class="fields-grid">
        <div class="form-field-row">
          <label>תנאי תשלום בישראל</label>
          <select class="form-control" apply-enter formControlName="defaultIlTermID">
            <option *ngFor="let term of servicesData.Terms" [ngValue]="term.id">
              {{term.name}}
            </option>
          </select>
        </div>

        <div class="form-field-row">
          <label>תנאי תשלום בארצות הברית</label>
          <select class="form-control" apply-enter formControlName="defaultUsaTermID">
            <option *ngFor="let term of servicesData.Terms" [ngValue]="term.id">
              {{term.name}}
            </option>
          </select>
        </div>

        <div class="form-field-row">
          <label>מיקום חשבון</label>
          <select class="form-control" apply-enter formControlName="defaultAccountLocation">
            <option *ngFor="let accountLocation of servicesData.AccountLocations" [ngValue]="accountLocation.value">
              {{accountLocation.name}}
            </option>
          </select>
        </div>

        <div class="form-field-row">
          <label>מטבע</label>
          <select class="form-control" apply-enter formControlName="defaultCurrency">
            <option *ngFor="let currency of servicesData.Currencies" [ngValue]="currency.value">
              {{currency.name}}
            </option>
          </select>
        </div>

        <div class="form-field-row">
          <label>קטגוריית תרומה</label>
          <select class="form-control" apply-enter formControlName="defaultDonationCategory">
            <option *ngFor="let category of servicesData.DonationCategories" [ngValue]="category.id">
              {{category.name}}
            </option>
          </select>
        </div>

        <div class="form-field-row">
          <label>נושא התחייבות</label>
          <select class="form-control" apply-enter formControlName="defaultCommitmentSubject">
            <option *ngFor="let subject of servicesData.CommitmentSubjects" [ngValue]="subject.value">
              {{subject.name}}
            </option>
          </select>
        </div>

        <div class="form-field-row">
          <label>סוג תרומה</label>
          <select class="form-control" apply-enter formControlName="defaultDonationType">
            <option *ngFor="let donationType of servicesData.DonationTypes" [ngValue]="donationType.value">
              {{donationType.name}}
            </option>
          </select>
        </div>
      </div>
    </fieldset>

    <fieldset class="options-card settings-group wide-card sensitive-settings">
      <legend>אימות שירות חיצוני</legend>
      <div class="fields-grid">
        <div class="form-field-row">
          <label>Access Token</label>
          <input type="password" class="form-control" apply-enter formControlName="accessToken"
            autocomplete="new-password">
        </div>

        <div class="form-field-row">
          <label>סוג Token</label>
          <input type="text" class="form-control" apply-enter formControlName="tokenType">
        </div>

        <div class="form-field-row">
          <label>תוקף בשניות</label>
          <input type="number" min="0" class="form-control" apply-enter formControlName="expiresIn">
        </div>
      </div>
    </fieldset>
  </div>

  <div class="app-options-footer">

    <footer-edit-buttons [dataProvider]="appOptionsData" [router]="router" [id]="id" [disabledDeleteButton]="id <= 0"
      [modelFormGroup]="appOptionForm"></footer-edit-buttons>

    <!-- <footer-edit-buttons [dataProvider]="appOptionsData"
    [router]="router" [id]="id" [disabledDeleteButton]="true" [modelFormGroup]="appOptionForm">
  </footer-edit-buttons> -->

    <!-- <button apply-enter [disabled]="appOptionForm.invalid" (click)="save()" class="btn btn-primary navbar-btn"><i class="fa fa-save"></i> שמור </button>
      <button class="btn btn-warning navbar-btn"><i class="fa fa-warning"></i> יציאה ללא שמירה</button> -->
  </div>
</div>


<ng-template #loading>
  <h3 class="loading-title">
    טוען נתונים...
  </h3>
</ng-template>
